import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGlobalStore } from '@/stores/global'
import { alertController } from '@ionic/core'
import { IonApp, IonRouterOutlet } from '@ionic/vue'
import { storeToRefs } from 'pinia'
import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { currentTerminal } = storeToRefs(useGlobalStore())

watch(currentTerminal, async () => {
    const alert = await alertController.create({
        header: `請重新啟動應用程式`,
        backdropDismiss: false,
    })
    await alert.present()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})